export const config = {
  photoBlock: {
    path: '/images/consultation/cto-eugene.webp',
    width: 300,
    height: 400,
    alt: 'Modsen CTO',
    title: 'Modsen CTO',
  },
  formBlock: {
    title: 'Free individual consultation',
    subtitle:
      'Leave your email and get a free estimate of your software development project.',
    personName: 'Eugene Kalugin,',
    personPosition: 'CTO',
    submitText: 'Thanks, we’ve got it!',
  },
  decorativeItems: [
    {
      path: '/images/cto-atom-figure.webp',
      width: 600,
      height: 600,
      alt: '',
      position: {
        top: -172,
        right: -170,
      },
    },
  ],
}
